import React from 'react'
import { useDropzone } from 'react-dropzone'

import type { UploadProps } from '@fourthwall/components'

import { FILE_TYPES, MAX_FILE_SIZE } from '../../const'
import { ActionButton } from '../ActionButton/ActionButton'

export type UploadActionButtonProps = {
  onFileDrop: UploadProps['onFileDrop']
  onFileDropRejected?: UploadProps['onFileDropRejected']
}

export const UploadActionButton = ({ onFileDrop, onFileDropRejected }: UploadActionButtonProps) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onFileDrop,
    onDropRejected: onFileDropRejected,
    maxSize: MAX_FILE_SIZE,
    accept: FILE_TYPES,
  })

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <ActionButton actionType="upload" />
    </div>
  )
}
